import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './multiplication.routes';
import addHtml from './modal/add.html';

export class MultiplicationController {
    $http;
    socket;
    awesomeThings = [];
    multiplications = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('multiplication');
        });
    }

    $onInit() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/multiplications/?all=true', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.multiplications = response.data.data;
                        this.socket.syncUpdates('multiplication', this.multiplications);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    // addThing() {
    //   if(this.newThing) {
    //     this.$http.post('/api/things', {
    //       name: this.newThing
    //     });
    //     this.newThing = '';
    //   }
    // }

    deleteMultiplication(multiplication, index) {
        this.$http.delete(`/api/multiplications/${multiplication.edition_id}/`).then(response => {
            if (response.status === 204) {
                this.multiplications.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }


    addMultiplication() {
        const multiplications = this.multiplications;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.vm = {};
                $scope.languageType = [
                    { value: 'pt', name: 'pt' },
                    { value: 'en', name: 'en' },
                    { value: 'es', name: 'es' }
                ]
                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        $scope.vm.size = $scope.vm.size + 'M';
                        $http.post('/api/multiplications', $scope.vm).then((response) => {
                            console.log(response.data);
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                console.log(ret);
                if (ret) {
                    multiplications.push(ret);
                }
            }, function () {
            });
    }

    updateMultiplication(multiplication, index) {
        const multiplications = this.multiplications;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.languageType = [
                    { value: 'pt', name: 'pt' },
                    { value: 'en', name: 'en' },
                    { value: 'es', name: 'es' }
                ]
                $scope.vm = angular.copy(multiplication);
                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        if ($scope.vm.size.indexOf('M') === -1) {
                            $scope.vm.size = $scope.vm.size + 'M';
                        }
                        $http.put('/api/multiplications/' + multiplication.edition_id + '/', $scope.vm).then((response) => {
                            console.log(response.data);
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                console.log(ret);
                if (ret) {
                    multiplications[index] = ret;
                }
            }, function () {
            });
    }

}

export default angular.module('tttApp.multiplication', [uiRouter])
    .config(routing)
    .component('multiplication', {
        template: require('./multiplication.html'),
        controller: MultiplicationController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/multiplication/multiplication.component.js